import { useMemo } from 'react';

import { ContactHoverCardWidget, AvatarSlotProps, UserAvatar, User } from '@sinups/ui-kit';
import { Box } from '@mantine/core';

export const AvatarCardWidget = ({ notification, ...other }: AvatarSlotProps) => {
  const user: User | null = useMemo(() => {
    if (!notification.userId) return null;

    return {
      id: notification.userId,
      fullName: notification.actor,
      avatarUrl: notification.imageUrl || ''
    };
  }, [notification]);

  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <ContactHoverCardWidget id={notification.userId} name={notification.actor}>
        <UserAvatar user={user} avatarProps={{ size: 30, ...other }} />
      </ContactHoverCardWidget>
    </Box>
  );
};
